import { render, staticRenderFns } from "./QuoteType1.vue?vue&type=template&id=55c5d391&scoped=true&"
import script from "./QuoteType1.vue?vue&type=script&lang=js&"
export * from "./QuoteType1.vue?vue&type=script&lang=js&"
import style0 from "./QuoteType1.vue?vue&type=style&index=0&id=55c5d391&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c5d391",
  null
  
)

export default component.exports